import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View, Pressable } from 'react-native';
import { useState } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { useFonts } from 'expo-font';


const resources = [
  {
    title: "Find some comedy (re-runs, stand up).",
    explanation: "Laughter can help shift your mood and reduce stress. Try watching a favorite comedian or show."
  },
  {
    title: "Ice pack for the head.",
    explanation: "Applying something cold can help ground you and reduce overwhelming sensations."
  },
  {
    title: "Somatic meditation.",
    explanation: "Gently massaging your ears can help you reconnect with your body and calm your nervous system."
  },
  {
    title: "5-2-10 breathing.",
    explanation: "Inhale for 5 seconds, hold for 2, exhale for 10. This can help regulate your breathing and calm anxiety."
  },
  {
    title: "Slow tapping + vision resources.",
    explanation: "Try slow tapping on your body or looking around the room to ground yourself in the present."
  },
  {
    title: "Paint with all the colors.",
    explanation: "Express yourself with colors. Art can be a powerful emotional outlet, and it gets your mind working in a different mode."
  },
  {
    title: "Take a bath or a shower.",
    explanation: "Warm water can be soothing and help you relax. You know a good scrub feels nice"
  },
  {
    title: "Find some loving touch (brush hair, light cuddling).",
    explanation: "Gentle touch can be comforting and help you feel safe and connected."
  },
  {
    title: "Practice an instrument.",
    explanation: "Deliberate practice or just splashing around on an instrument will activate your brain in a different way."
  },
  {
    title: "Get some music playing.",
    explanation: "Music can shift your mood. Choose something that feels right for you."
  },
  {
    title: "Communicate with other parts of yourself",
    explanation: "Thank the part of you that is feeling overwhelmed for it's service. Get out the art supplies and draw abstractions of yourself."
  },
  {
    title: "Create a comforting environment (gentle music, dim the lights, tidy up the space around you).",
    explanation: "A soothing environment can help you feel more at ease and in control. You might accidentally clean up a bit, too."
  },
  {
    title: "Be a blank canvas: Do breathing exercises with a focus on the exhale.",
    explanation: "Focusing on your breath, especially the exhale, can help you reset and calm down."
  },
  {
    title: "Be assured: You are not alone, you are not in immediate danger. You are safe.",
    explanation: "It's going to be okay."
  },
  {
    title: "Express some feelings through art.",
    explanation: "Let your emotions flow onto paper or canvas. Art can help process feelings."
  },
  {
    title: "If you are in a public place... consider finding some privacy.",
    explanation: "A private space can help you feel safer and more comfortable to self-soothe."
  },
  {
    title: "Have a snack or a drink (water, tea, juice).",
    explanation: "Nourishing your body can help stabilize your mood and energy."
  },
  {
    title: "List things ^^ (colors, sea creatures, favorite foods).",
    explanation: "Listing things can distract your mind and help you feel more grounded."
  }
];

function getRandomResource() {
  const idx = Math.floor(Math.random() * resources.length);
  return resources[idx];
}

export default function App() {
  const [fontsLoaded] = useFonts({
    EBGaramond: require('./assets/fonts/EBGaramond-VariableFont_wght.ttf'),
  });

  const [resource, setResource] = useState(getRandomResource());
  const nextResource = () => {
    setResource(getRandomResource());
  };

  if (!fontsLoaded) {
    return null; // TODO replace null with loading spinner
  }

  return (
    <LinearGradient
      colors={['#c1794fff', '#a8ddf5ff', '#e357a9ff']}
      style={styles.gradient}
      start={{ x: 0, y: 0 }} 
      end={{ x: 1, y: 1 }}   
    >
      <View style={styles.container}>
        <Text style={[styles.resourceText, { fontFamily: 'EBGaramond' }]}>{resource.title}</Text>
        <Pressable style={styles.button} onPress={nextResource}>
          <Text style={[styles.buttonText, { fontFamily: 'EBGaramond' }]}>Next Resource</Text>
        </Pressable>
        <Text style={[styles.explanationText, { fontFamily: 'EBGaramond' }]}>{resource.explanation}</Text>
        <StatusBar style="auto" />
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  gradient: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  resourceText: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 24,
  },
  button: {
    borderWidth: 2,
    borderColor: '#fff',
    borderRadius: 24,
    paddingVertical: 12,
    paddingHorizontal: 32,
    backgroundColor: 'rgba(255,255,255,0.15)',
    marginBottom: 16,
    shadowColor: '#a8ddf5',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 2,
  },
  buttonText: {
    color: '#22405eff',
    fontSize: 18,
    fontWeight: '600',
    letterSpacing: 1,
    textAlign: 'center',
  },
  explanationText: {
    fontSize: 16,
    color: '#22405eff',
    marginTop: 12,
    textAlign: 'center',
    opacity: 0.85,
  },
});